import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { formatDate, parseLocalDateInput } from 'helpers/helpers'

function ModalTaskStatus({
	pendingMove,
	setPendingMove,
	submitTaskStatus,
	modalTaskStatus,
	toggleModalTaskStatus,
}) {
	const { t } = useTranslation()

	function handleSubmit(e) {
		e.preventDefault()
		submitTaskStatus()
	}

	return (
		<Modal show={modalTaskStatus} animation={false} centered size="md"
			dialogClassName="update-modal-width"
			onHide={() => toggleModalTaskStatus()}>
			<Modal.Header closeButton>
				<Modal.Title>{pendingMove?.statusName || t('task_new_deadline')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={(e) => handleSubmit(e)} autoComplete="off">
					<div className="form-group">
						<label>{t('task')}</label>
						<div className="fw-600">{pendingMove?.task?.name}</div>
					</div>

					<div className="form-group">
						<label>{t('task_previous_deadline')}</label>
						<div className="fw-600">
							{pendingMove?.task?.deadline ? formatDate(pendingMove.task.deadline, 'dd.MM.yyyy') : '-'}
						</div>
					</div>

					<div className="form-group">
						<label>{t('task_new_deadline')}<span className="required-mark">*</span></label>
						<DatePicker
							showMonthDropdown
							showYearDropdown
							dropdownMode="select"
							selected={parseLocalDateInput(pendingMove?.deadline)}
							onChange={(date) => setPendingMove({
								...pendingMove,
								'deadline': date ? formatDate(date, 'yyyy-MM-dd') : '',
							})}
							dateFormat="dd.MM.yyyy"
							className="form-control"
							minDate={new Date()}
						/>
					</div>

					<div className="form-group">
						<label>{t('task_move_comment')}</label>
						<textarea className="form-control" rows={2}
							value={pendingMove?.comment || ''}
							onChange={(e) => setPendingMove({ ...pendingMove, 'comment': e.target.value })} />
					</div>

					<div className="d-flex w-100 mt-3 gap-2">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleModalTaskStatus()}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100"
							disabled={!pendingMove?.deadline}>
							{t('save')}
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	)
}

export default ModalTaskStatus
